/* SSi website – Arabic landing page hero. Mirrors SpanishHero.jsx — same A/B variants. */
import { Link } from 'react-router-dom';

export function ArabicHero({ onStart, t }) {
  const variant = t.arHeroVariant || 'A';
  return variant === 'B'
    ? <ArabicHeroB onStart={onStart} t={t}/>
    : <ArabicHeroA onStart={onStart} t={t}/>;
}

function ArabicHeroA({ onStart, t }) {
  return (
    <section className="ssi-arHero ssi-arHero--A" style={arHeroStyles.wrapA}>
      <div className="ssi-arHero__leftA" style={arHeroStyles.leftA}>
        {t.arHeroKicker && <div style={arHeroStyles.kicker}>{t.arHeroKicker}</div>}
        <h1 style={arHeroStyles.h1}>{t.arHeroTitle}</h1>
        <p style={arHeroStyles.lede}>{t.arHeroSub1}</p>
        <p style={arHeroStyles.lede}>{t.arHeroSub2}</p>
        <div style={arHeroStyles.ctas}>
          <Link to="/pay?course=en-ar" className="btn btn--onDark">{t.arHeroCta1}</Link>
          <a href="#sample" className="btn" style={arHeroStyles.ghost}>{t.arHeroCta2}</a>
        </div>
        <p style={arHeroStyles.trust}>{t.arHeroTrust}</p>
      </div>
      <div className="ssi-arHero__rightA" style={arHeroStyles.rightA}>
        <img src="/assets/hero_woman_hijab_onred.jpg?v=6" alt="" style={arHeroStyles.heroImg}/>
        <div className="ssi-arHero__bubble" style={arHeroStyles.bubble} aria-hidden>
          <span style={arHeroStyles.bubbleWord}>{t.arHeroBubble || "مرحبا!"}</span>
          <span style={arHeroStyles.bubbleTail}/>
        </div>
      </div>
    </section>
  );
}

function ArabicHeroB({ onStart, t }) {
  return (
    <section className="ssi-arHero ssi-arHero--B" style={arHeroStyles.wrapB}>
      <div className="ssi-arHero__innerB" style={arHeroStyles.innerB}>
        <div className="ssi-arHero__giantWrap" style={arHeroStyles.giantWrap}>
          <span style={arHeroStyles.giantTranslate}>(verb) to speak — takallam</span>
          <div style={arHeroStyles.giant} aria-hidden>{t.arHeroGiantWord}</div>
          <div style={arHeroStyles.giantUnderline}/>
        </div>
        <div style={arHeroStyles.copyB}>
          {t.arHeroKicker && <div style={arHeroStyles.kickerB}>{t.arHeroKicker}</div>}
          <h1 style={arHeroStyles.h1B}>{t.arHeroTitle}</h1>
          <p style={arHeroStyles.ledeB}>{t.arHeroSub1}</p>
          <p style={arHeroStyles.ledeB}>{t.arHeroSub2}</p>
          <div style={arHeroStyles.ctas}>
            <Link to="/pay?course=en-ar" className="btn btn--onDark">{t.arHeroCta1}</Link>
            <a href="#sample" className="btn" style={arHeroStyles.ghost}>{t.arHeroCta2}</a>
          </div>
          <p style={arHeroStyles.trustB}>{t.arHeroTrust}</p>
        </div>
      </div>
    </section>
  );
}

const arHeroStyles = {
  kicker: { fontSize: 12, letterSpacing: '.18em', textTransform: 'uppercase', color: '#FFD8D4', fontWeight: 600, marginBottom: 18 },
  h1: { fontFamily: 'var(--font-display)', fontSize: 64, lineHeight: 1.04, color: '#fff', letterSpacing: '-.015em', margin: '0 0 20px', textWrap: 'balance' },
  lede: { fontSize: 18, lineHeight: 1.55, color: 'rgba(255,255,255,.92)', margin: '0 0 18px', maxWidth: 540 },
  ctas: { display: 'flex', gap: 12, marginTop: 20, marginBottom: 24 },
  ghost: { background: 'transparent', color: '#fff', border: '1px solid rgba(255,255,255,.5)' },
  trust: { fontSize: 13, color: 'rgba(255,255,255,.72)', margin: 0 },
  wrapA: { background: 'var(--brandRed)', color: '#fff', padding: '88px 0 88px', position: 'relative', overflow: 'hidden', minHeight: 560 },
  leftA: { maxWidth: 600, padding: '0 32px', position: 'relative', zIndex: 2 },
  rightA: { position: 'absolute', right: 0, top: 0, bottom: 0, width: '50%', display: 'flex', alignItems: 'flex-end', justifyContent: 'center' },
  heroImg: { width: '100%', height: '100%', objectFit: 'cover', objectPosition: 'center bottom', maskImage: 'linear-gradient(to right, transparent 0%, black 18%)', WebkitMaskImage: 'linear-gradient(to right, transparent 0%, black 18%)' },
  bubble: { position: 'absolute', left: 'calc(10% )', top: 64, background: "#FFD84D", color: '#490300', padding: '18px 28px 22px', borderRadius: 18, transform: 'rotate(-5deg)', boxShadow: '0 18px 40px -14px rgba(0,0,0,.35), 0 2px 0 rgba(0,0,0,.08)', zIndex: 3 },
  bubbleWord: { fontFamily: 'var(--font-display)', fontWeight: 700, fontSize: 52, lineHeight: 1, letterSpacing: '-.02em', display: 'inline-block', fontStyle: 'italic' },
  bubbleTail: { position: 'absolute', left: 36, bottom: -12, width: 22, height: 22, background: "#FFD84D", borderBottomLeftRadius: 4, borderStyle: 'solid', borderWidth: '0 0 2px 2px', borderColor: 'transparent', transform: 'rotate(-45deg)' },
  wrapB: { background: 'var(--brandRed)', color: '#fff', padding: '80px 0 88px', position: 'relative', overflow: 'hidden' },
  innerB: { maxWidth: 1240, margin: '0 auto', padding: '0 32px', display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 56, alignItems: 'center' },
  giantWrap: { position: 'relative' },
  giantTranslate: { display: 'inline-block', fontSize: 13, color: 'rgba(255,255,255,.7)', letterSpacing: '.02em', fontStyle: 'italic', marginBottom: 4, marginLeft: 4 },
  giant: { fontFamily: 'var(--font-display)', fontSize: 'clamp(96px, 13vw, 200px)', lineHeight: .95, fontWeight: 700, letterSpacing: '-.03em', color: '#fff', margin: 0 },
  giantUnderline: { width: 80, height: 4, background: '#FFD84D', borderRadius: 4, marginTop: 20, marginLeft: 4 },
  copyB: { maxWidth: 520 },
  kickerB: { fontSize: 12, letterSpacing: '.18em', textTransform: 'uppercase', color: '#FFD8D4', fontWeight: 600, marginBottom: 16 },
  h1B: { fontFamily: 'var(--font-display)', fontSize: 44, lineHeight: 1.1, color: '#fff', letterSpacing: '-.015em', margin: '0 0 18px', textWrap: 'balance' },
  ledeB: { fontSize: 16.5, lineHeight: 1.55, color: 'rgba(255,255,255,.92)', margin: '0 0 16px', maxWidth: 520 },
  trustB: { fontSize: 13, color: 'rgba(255,255,255,.72)', margin: 0 },
};
